import { IsInt } from 'class-validator';

export class CreateRebateMerchantDto {
  @IsInt()
  rebateId: number;

  @IsInt()
  merchantId: number;
}